import { StyleSheet } from 'react-native';
import { spacing, ticketColors, ticketFonts } from '../theme/public-api';

/**
 * Chrome compartido para overlays ticket (sheet / dialog).
 * Sheet = paper elevada; inputs/controles se leen por borde control.
 */
export const ticketChrome = StyleSheet.create({
  sheetBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'flex-end',
  },
  sheetCard: {
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    borderTopWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingTop: 8,
    maxHeight: '96%',
    overflow: 'hidden',
  },
  grabber: {
    width: 28,
    height: 3,
    borderRadius: 2,
    backgroundColor: ticketColors.ruleSoft,
    alignSelf: 'center',
    marginTop: 2,
    marginBottom: 12,
  },
  /**
   * Cabecera sheet mobile: X siempre arriba a la derecha (misma altura entre modales).
   * No usar `alignItems: 'center'` — con subtítulo la X bajaba.
   */
  sheetHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    paddingHorizontal: 18,
    marginBottom: 8,
  },
  sheetTitle: {
    fontSize: 13,
    fontWeight: '600',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  sheetSubtitle: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.ink,
    marginTop: 6,
    fontFamily: ticketFonts.sans,
  },
  /** Hit target fijo 32 — mismo en todos los sheets mobile. */
  sheetCloseBtn: {
    width: 32,
    height: 32,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  sheetCloseGlyph: {
    fontSize: 18,
    fontWeight: '400',
    color: ticketColors.ink2,
    lineHeight: 20,
    marginTop: -1,
  },
  dialogCard: {
    backgroundColor: ticketColors.paper,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    overflow: 'hidden',
    zIndex: 1,
    maxHeight: '90%',
  },
  panel: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    padding: spacing.md,
    gap: spacing.sm,
  },
  panelTitle: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.08 * 11,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    marginBottom: 4,
    fontFamily: ticketFonts.sans,
  },
  foot: {
    flexShrink: 0,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 16,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
  },
  btnGhost: {
    minHeight: 44,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 14,
  },
  btnGhostText: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  btnGold: {
    minHeight: 44,
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 14,
  },
  btnGoldText: {
    fontSize: 14,
    fontWeight: '800',
    color: ticketColors.goldInk,
    fontFamily: ticketFonts.sans,
  },
  btnDanger: {
    minHeight: 44,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(185,28,28,0.28)',
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 14,
  },
  btnDangerText: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.bad,
    fontFamily: ticketFonts.sans,
  },
});
